/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { PostService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import { toastEmmit } from "../../../Helper/Toastr";
import { BounceLoader } from "react-spinners";

export default function ChangePassword() {
  const [loading, setLoading] = useState(false);
  const [showPasswords, setShowPasswords] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const toggleShowPassword = (field) => {
    setShowPasswords((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required("Old password is required"),
    newPassword: Yup.string()
      .required("New password is required")
      .notOneOf(
        [Yup.ref("oldPassword")],
        "New password must be different from old password"
      ),
    confirmPassword: Yup.string()
      .required("Confirm password is required")
      .oneOf([Yup.ref("newPassword")], "Passwords must match"),
  });

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: (values) => {
      if (localStorage.getItem("userType") === "guestLogin") {
        toastEmmit(
          "error",
          "Currently on a Guest account, Please Login with a valid account to change"
        );
        return;
      }
      setLoading(true);
      PostService(API_URL.CHANGE_PASSWORD, values).then((res) => {
        setLoading(false);
        if (res.data?.status === true) {
          toastEmmit("success", res?.data?.message);
          formik.resetForm();
        } else {
          toastEmmit("error", res?.data?.message || "Something went wrong");
        }
      });
    },
  });

  return (
    <>
      <div
        className="tab-pane fade active show"
        id="nav-Brochure"
        role="tabpanel"
        aria-labelledby="nav-Brochure-tab"
        tabIndex={0}
      >
        <div className="tp-best-product-4__item-box">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-6">
              <div className="heading">
                <p>Change Password</p>
              </div>
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className=" input">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="tp-contact-4__input-box mb-20">
                        <label>
                          Old Password<sup className="error">*</sup>
                        </label>
                        <input
                          type={showPasswords.oldPassword ? "text" : "password"}
                          name="oldPassword"
                          placeholder="Enter Your Old Password"
                          value={formik.values.oldPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <i
                          className={
                            showPasswords.oldPassword
                              ? "fa-regular fa-eye"
                              : "fa-regular fa-eye-slash"
                          }
                          onClick={() => toggleShowPassword("oldPassword")}
                          style={{
                            cursor: "pointer",
                            top: "50px",
                            right: "25px",
                            position: "absolute",
                          }}
                        />
                        {formik.touched.oldPassword &&
                          formik.errors.oldPassword && (
                            <div className="error mt-1">
                              {formik.errors.oldPassword}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="tp-contact-4__input-box mb-20">
                        <label>
                          New Password<sup className="error">*</sup>
                        </label>
                        <input
                          type={showPasswords.newPassword ? "text" : "password"}
                          name="newPassword"
                          placeholder="Enter New Password"
                          value={formik.values.newPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <i
                          className={
                            showPasswords.newPassword
                              ? "fa-regular fa-eye"
                              : "fa-regular fa-eye-slash"
                          }
                          onClick={() => toggleShowPassword("newPassword")}
                          style={{
                            cursor: "pointer",
                            top: "50px",
                            right: "25px",
                            position: "absolute",
                          }}
                        />
                        {formik.touched.newPassword &&
                          formik.errors.newPassword && (
                            <div className="error mt-1">
                              {formik.errors.newPassword}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="tp-contact-4__input-box mb-20">
                        <label>
                          Confirm Password<sup className="error">*</sup>
                        </label>
                        <input
                          type={
                            showPasswords.confirmPassword ? "text" : "password"
                          }
                          name="confirmPassword"
                          placeholder="Confirm Password"
                          value={formik.values.confirmPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <i
                          className={
                            showPasswords.confirmPassword
                              ? "fa-regular fa-eye"
                              : "fa-regular fa-eye-slash"
                          }
                          onClick={() => toggleShowPassword("confirmPassword")}
                          style={{
                            cursor: "pointer",
                            top: "50px",
                            right: "25px",
                            position: "absolute",
                          }}
                        />
                        {formik.touched.confirmPassword &&
                          formik.errors.confirmPassword && (
                            <div className="error mt-1">
                              {formik.errors.confirmPassword}
                            </div>
                          )}
                        {/* {formik.touched.password && formik.errors.password ? (
                          <div className="error mt-1">
                            {formik.errors.password}
                          </div>
                        ) : null} */}
                      </div>
                    </div>
                  </div>
                  <div className="tp-contact-4__input-box mb-30 mt-30">
                    <button
                      type="submit"
                      className="tp-btn-lg large head"
                      disabled={loading}
                    >
                      {loading ? "Changing..." : "Change"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#607fe6"}
            loading={loading}
            speedMultiplier={2}
            size={50}
          />
          <div className="fw-semibold">Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
